<template>
  <image
    :id="htmlId(shape._id)"
    v-bind="$attrs"
    class="shape"
    :href="shape.src"
    :x="shape.points[0].x"
    :y="shape.points[0].y"
    :width="width"
    :height="height"
    preserve-aspect-ratio="none"
  />
</template>

<script lang="ts" setup>
import { htmlId } from '../utils/utils';
import { Image } from '../models/shapes';
import { computed } from 'vue';

const props = defineProps<{
  id: string;
}>();

const shape = computed(() => Image.get(props.id)!);

const { x: width, y: height } = shape.value.points[1].sub(shape.value.points[0]);
</script>

<style scoped>
.tool {
  animation: 1s infinite linear stroke;
}

@keyframes stroke {
  0% {
    stroke-dashoffset: 0;
  }
  100% {
    stroke-dashoffset: 10;
  }
}
</style>
